// @core/api/endpoints/landing/list_landing_templates.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListLandingTemplatesResponse,
} from '../../../types/landing';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/landing';

/**
 * List landing templates
 * Returns available landing page templates. Supports filtering by category.
 */
export async function ListLandingTemplates(
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListLandingTemplatesResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/landing/templates`;
  const requestOptions = options;
  return client.get<ListLandingTemplatesResponse>(requestPath, { ...requestOptions, params });
}
